import algoliasearch from 'algoliasearch/lite';

const searchClient = algoliasearch(
  process.env.GATSBY_ALGOLIA_ID,
  process.env.GATSBY_ALGOLIA_API,
);

export { searchClient };
